import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Menu, MenuWrapper, ButtonContainer, CloseButton } from '@/components/GlobalMenu/Mobile/MobileMenu.style';
import MenuOuter from './MenuOuter';
import MenuInner from './MenuInner';
import { close } from './icons';

/**
 * メニュー (SP 版 ヘッダー / フッター共用コンポーネント)
 *   ヘッダー非表示内容、且つ、フッター表示内容
 *     1. CONTACT US、2. SITEMAP、3. SHISEIDO GROUP リンク、4. SNS リンク、5. 利用規約、6. 個人情報保護方針、7. コピーライト
 */
class MobileMenu extends React.Component {
  static defaultProps = {
    screenSize: null,
    closeMenu: null,
    menu: [],
    isFooterMenu: false,
    primaryLinks: [],
  };

  static propTypes = {
    open: PropTypes.bool.isRequired,
    screenSize: PropTypes.number,
    closeMenu: PropTypes.func,
    menu: PropTypes.arrayOf(PropTypes.shape()),
    isFooterMenu: PropTypes.bool,
    // フッター表示内容 (例) CONTACT US) を含む情報
    primaryLinks: PropTypes.arrayOf(PropTypes.shape()),
  };

  state = {
    nestedMenuOpen: false,
    category: {},
    label: '',
  };

  componentDidUpdate = prevProps => {
    const { open, isFooterMenu } = this.props;
    const { prevOpen } = prevProps;

    if (open !== prevOpen) {
      if (open) {
        document.body.style.overflowY = 'hidden';
      } else {
        document.body.style.overflowY = 'auto';
      }
    }

    if (isFooterMenu) {
      document.body.style.overflowY = 'auto';
    }
  };

  componentWillUnmount = () => {
    document.body.style.overflowY = 'auto';
  };

  openGroup = (label, category) => {
    this.setState({
      nestedMenuOpen: true,
      category,
      label,
    });
  };

  closeGroup = () => {
    this.setState({ nestedMenuOpen: false });
  };

  render() {
    const { category, label, nestedMenuOpen } = this.state;
    const { closeMenu, open, menu, isFooterMenu, screenSize, primaryLinks } = this.props;

    return (
      <Menu show={open} className={isFooterMenu ? 'footerMenu' : 'headerMenu'}>
        {!isFooterMenu && (
          <ButtonContainer>
            <CloseButton onClick={closeMenu} close={close} />
          </ButtonContainer>
        )}

        <MenuWrapper>
          <MenuOuter
            closeMenu={closeMenu}
            menu={isFooterMenu ? primaryLinks : menu}
            nestedMenuOpen={nestedMenuOpen}
            openGroup={this.openGroup}
            isFooterMenu={isFooterMenu}
            screenSize={screenSize}
          />

          <MenuInner
            close={this.closeGroup}
            closeMenu={closeMenu}
            category={category}
            label={label}
            nestedMenuOpen={nestedMenuOpen}
            isFooterMenu={isFooterMenu}
          />
        </MenuWrapper>
      </Menu>
    );
  }
}

const mapState = state => ({
  menu: state.siteOptions.menu,
  // フッター表示内容 (例) CONTACT US) を含む情報
  primaryLinks: state.siteOptions.footerPrimaryLinks,
});

export default connect(mapState)(MobileMenu);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MobileMenu.js